import { render } from "./ShowIndex.vue?vue&type=template&id=f8d6a8f2"
import script from "./ShowIndex.vue?vue&type=script&lang=js"
export * from "./ShowIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__